var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.23678 9.44585C6.45678 8.66585 5.86878 7.79252 5.47811 6.90652C5.39545 6.71918 5.44411 6.49985 5.58878 6.35518L6.13478 5.80985C6.58211 5.36252 6.58211 4.72985 6.19145 4.33918L5.40878 3.55652C4.88811 3.03585 4.04411 3.03585 3.52345 3.55652L3.08878 3.99118C2.59478 4.48518 2.38878 5.19785 2.52211 5.90452C2.85145 7.64652 3.86345 9.55385 5.49611 11.1865C7.12878 12.8192 9.03611 13.8312 10.7781 14.1605C11.4848 14.2938 12.1974 14.0878 12.6914 13.5938L13.1254 13.1598C13.6461 12.6392 13.6461 11.7952 13.1254 11.2745L12.3434 10.4925C11.9528 10.1018 11.3194 10.1018 10.9294 10.4925L10.3274 11.0952C10.1828 11.2398 9.96345 11.2885 9.77611 11.2058C8.89011 10.8145 8.01678 10.2258 7.23678 9.44585Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b38c344094feed986dca625c56ebdad3.svg";
export { ForwardRef as ReactComponent };